"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _featureDetection = require("js-utils/feature-detection");

var _http = require("js-utils/http");

var _GlobalHeader = _interopRequireDefault(require("eventbrite_design_system/globalHeader/GlobalHeader"));

var _utils = require("./utils");

var _constants = require("./constants");

var _search = require("./utils/search");

var _userLocation = require("./utils/userLocation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SEARCH_SUGGESTIONS_THROTTLE_AMOUNT = 300;
var getSuggestionsThrottled = (0, _throttle.default)(_search.getSuggestions, SEARCH_SUGGESTIONS_THROTTLE_AMOUNT);
var getDestinstionSuggestionsThrottled = (0, _throttle.default)(_search.getDestinationSuggestions, SEARCH_SUGGESTIONS_THROTTLE_AMOUNT);

var SiteHeader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SiteHeader, _React$Component);

  function SiteHeader(props) {
    var _this;

    _classCallCheck(this, SiteHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteHeader).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_setUserLocationOnState", function () {
      var searchLocation = _this.props.env.searchLocation;

      _this.setState({
        userLocation: (0, _userLocation.getUserLocationFromRequest)(searchLocation)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSearchChange", function (searchQuery) {
      if (!_this.props.onSearchFocus) {
        if (_this.props.env.useDestinationAutocomplete) {
          getDestinstionSuggestionsThrottled(searchQuery, _this.state.userLocation).then(function (searchSuggestions) {
            _this.setState({
              searchQuery: searchQuery,
              searchSuggestions: searchSuggestions
            });
          });
        } else {
          getSuggestionsThrottled(searchQuery).then(function (searchSuggestions) {
            _this.setState({
              searchQuery: searchQuery,
              searchSuggestions: searchSuggestions
            });
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSearchSubmit", function (query) {
      var LUX = (0, _featureDetection.getWindowObject)('LUX');

      if (LUX) {
        LUX.mark('ch-search-sent');
      }

      if (!query) {
        (0, _http.setWindowLocation)("/d/local/all-events");
      } else {
        (0, _http.setWindowLocation)("/d/?q=".concat(query));
      }
    });

    _this.state = {
      searchQuery: props.env.searchQuery || '',
      searchSuggestions: _constants.FALLBACK_SUGGESTIONS
    };
    return _this;
  }

  _createClass(SiteHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var LUX = (0, _featureDetection.getWindowObject)('LUX');

      if (LUX) {
        LUX.mark('ch-search-ready');
      }

      if (this.props.env.useDestinationAutocomplete) {
        this._setUserLocationOnState();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          env = _this$props.env,
          request = _this$props.request,
          user = _this$props.user,
          onSearchSelect = _this$props.onSearchSelect,
          hideSearchBar = _this$props.hideSearchBar,
          onSearchFocus = _this$props.onSearchFocus;
      var _this$state = this.state,
          searchQuery = _this$state.searchQuery,
          searchSuggestions = _this$state.searchSuggestions;
      var serverUrl = env.serverUrl,
          adminServerUrl = env.adminServerUrl,
          loginUrl = env.loginUrl,
          logoutUrl = env.logoutUrl,
          helpUrls = env.helpUrls,
          organizeUrls = env.organizeUrls,
          ebDomain = env.ebDomain,
          isManageOverviewActive = env.isManageOverviewActive;
      var requestPath = request.path;
      var isAuthenticated = user.isAuthenticated,
          canCreateEvents = user.canCreateEvents,
          isSuperCreator = user.isSuperCreator;
      var additionalMenus = [(0, _utils.getHelpMenu)(helpUrls, requestPath, isSuperCreator)];

      if ((0, _utils.isHomepage)(requestPath)) {
        additionalMenus = [(0, _utils.getOrganizeMenu)(organizeUrls, requestPath)].concat(_toConsumableArray(additionalMenus));
      }

      return _react.default.createElement(_GlobalHeader.default, {
        logoInfo: (0, _utils.getLogoInfo)(serverUrl, requestPath),
        searchInfo: (0, _utils.getSearchInfo)(serverUrl, searchQuery, searchSuggestions, hideSearchBar),
        quickLinks: (0, _utils.getBrowseEventsQuickLinks)(serverUrl, ebDomain, requestPath, this.props.showReportBugLinkInHeader),
        userMenuInfo: (0, _utils.getUserMenuInfo)({
          serverUrl: serverUrl,
          adminServerUrl: adminServerUrl,
          logoutUrl: logoutUrl,
          requestPath: requestPath,
          user: user,
          isManageOverviewActive: isManageOverviewActive,
          showBrowseEvents: hideSearchBar
        }),
        additionalMenus: additionalMenus,
        nonUserQuickLinks: (0, _utils.getNonUserQuickLinks)(requestPath, isAuthenticated, loginUrl),
        callToActionInfo: (0, _utils.getCreateEventCTA)(serverUrl, ebDomain, requestPath, isAuthenticated, canCreateEvents),
        onSearchChange: this._handleSearchChange,
        onSearchSelect: onSearchSelect,
        onSearchFocus: onSearchFocus,
        onSearchSubmit: this._handleSearchSubmit
      });
    }
  }]);

  return SiteHeader;
}(_react.default.Component);

exports.default = SiteHeader;

_defineProperty(SiteHeader, "propTypes", {
  env: _constants.ENV_SHAPE_PROP_TYPE.isRequired,
  request: _constants.REQUEST_SHAPE_PROP_TYPE.isRequired,
  user: _constants.USER_SHAPE_PROP_TYPE.isRequired,
  onSearchSelect: _propTypes.default.func,
  hideSearchBar: _propTypes.default.bool,
  onSearchFocus: _propTypes.default.func
});
//# sourceMappingURL=SiteHeader.js.map